import React from "react";
import './Projects.css'
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import WebDev from "./WebDev";
import Analytics from "./Analytics";
import ML from './ML'
import Backend from "./Backend";

export default function Projects() {

    return (
        <Tabs>
            <TabList style={{ marginTop: "10px", fontSize: "25px", fontFamily: "Signika", fontWeight: "1000", color: "white" }}>
                <Tab >Web Dev</Tab>
                <Tab >Backend</Tab>
                <Tab >ML</Tab>
                <Tab >Analytics</Tab>
            </TabList>

            <TabPanel>
                <WebDev />
            </TabPanel>
            <TabPanel>
                <Backend/>
            </TabPanel>
            <TabPanel>
                <ML />
            </TabPanel>
            <TabPanel>
                <Analytics />
            </TabPanel>
        </Tabs>
    );
}